import { SvgMobile, SvgBusiness, SvgHome } from "./svg";

interface PhoneTypeIconProps {
  type: string;
  dnc?: boolean;
  className?: string;
}

export default function PhoneTypeIcon({ type, dnc = false, className = "" }: PhoneTypeIconProps) {
  const colorClass =
    dnc
      ? "text-red-500 fill-red-700"
      : "text-success fill-success";

  const combinedClass = `md:text-[12px] text-[12px] ${colorClass} ${className}`;

  switch (type) {
    case "M":
      return <SvgMobile className={combinedClass} />;
    case "B":
      return <SvgBusiness className={combinedClass} />;
    case "R":
      return <SvgHome className={combinedClass} />;
    default:
      return null;
  }
} 